// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════
   Song Details Page — SIKI Design System
   ═══════════════════════════════════════════════════════════════ */

.sd-page {
  background: linear-gradient(135deg, #0a0a0a 0%, #111118 100%);
  min-height: 100vh;
  color: #fff;
  padding-bottom: 100px;
}

/* ── Back Button ──────────────────────────────────────────────── */
.sd-back {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0 0 16px;
  color: rgba(255, 255, 255, 0.45);
  font-size: 13px;
  cursor: pointer;
  transition: color 0.2s;
  max-width: 1200px;
  margin: 0 auto;
}
.sd-back:hover { color: #fff; }
.sd-back svg { font-size: var(--text-sm); }

/* ── Hero Section ─────────────────────────────────────────────── */
.sd-hero {
  position: relative;
  overflow: hidden;
  padding: 48px 32px 40px;
}
.sd-hero-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}
.sd-hero-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: blur(60px) brightness(0.3);
  transform: scale(1.2);
}
.sd-hero-bg::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(10,10,10,0.2) 0%, rgba(10,10,10,0.65) 55%, rgba(10,10,10,0.95) 100%);
}
.sd-hero-content {
  position: relative;
  z-index: 1;
  display: flex;
  gap: 32px;
  align-items: flex-start;
  max-width: 1200px;
  margin: 0 auto;
}
.sd-hero-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.sd-hero-cover {
  width: 220px;
  height: 220px;
  object-fit: cover;
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.06);
  flex-shrink: 0;
}

/* Hero typography */
.sd-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.sd-title {
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  line-height: 1.2;
}
.sd-artist {
  font-size: var(--text-md);
  color: rgba(255,255,255,0.65);
  cursor: pointer;
  transition: color 0.2s;
}
.sd-artist:hover { color: #ffee20; }

/* ── Stat Cards ───────────────────────────────────────────────── */
.sd-stat-row {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 4px;
}
.sd-stat-card {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 10px;
  padding: 8px 14px;
  -webkit-backdrop-filter: blur(12px);
          backdrop-filter: blur(12px);
  transition: border-color 0.2s;
}
.sd-stat-card:hover { border-color: rgba(255,238,32,0.3); }
.sd-stat-icon { font-size: var(--text-lg); color: #ffee20; }
.sd-stat-value {
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  line-height: 1.2;
}
.sd-stat-label {
  font-size: 11px;
  color: rgba(255,255,255,0.4);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1.2;
}

/* ── Collectable Badge ────────────────────────────────────────── */
.sd-collectable-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 8px;
  background: rgba(255,238,32,0.12);
  border: 1px solid rgba(255,238,32,0.35);
  font-size: var(--text-xs);
  color: #ffee20;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

/* ── Action Buttons ───────────────────────────────────────────── */
.sd-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
}
.sd-btn-play {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 28px;
  background: #ffee20;
  color: #000;
  font-weight: 600;
  font-size: var(--text-sm);
  border: none;
  border-radius: 25px;
  cursor: pointer;
  transition: background 0.2s;
}
.sd-btn-play:hover { background: #e6d61c; }
.sd-btn-play svg { font-size: var(--text-lg); }
.sd-btn-share {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 20px;
  background: transparent;
  color: #fff;
  font-size: 13px;
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 25px;
  cursor: pointer;
  transition: border-color 0.2s;
}
.sd-btn-share:hover { border-color: rgba(255,255,255,0.5); }
.sd-btn-share svg { font-size: var(--text-md); }
.sd-btn-more {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.1);
  color: rgba(255,255,255,0.7);
  cursor: pointer;
  transition: all 0.2s;
}
.sd-btn-more:hover {
  background: rgba(255,255,255,0.1);
  color: #fff;
}

/* ── Tab Navigation ───────────────────────────────────────────── */
.sd-tabs-wrapper {
  position: sticky;
  top: 0;
  z-index: 10;
  background: rgba(10,10,10,0.95);
  -webkit-backdrop-filter: blur(12px);
          backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255,238,32,0.1);
  padding: 0 32px;
  max-width: 1200px;
  margin: 0 auto;
}

/* ── Layout: Main + Sidebar ───────────────────────────────────── */
.sd-layout {
  display: flex;
  gap: 0;
  max-width: 1200px;
  margin: 0 auto;
  padding: 28px 32px;
}
.sd-main {
  flex: 1;
  min-width: 0;
  padding-right: 32px;
}
.sd-sidebar {
  width: 340px;
  flex-shrink: 0;
  border-left: 1px solid rgba(255,238,32,0.08);
  padding-left: 24px;
}

/* ── Section Titles ───────────────────────────────────────────── */
.sd-section {
  margin-bottom: 32px;
}
.sd-section-title {
  font-size: var(--text-md);
  font-weight: 700;
  color: #fff;
  margin-bottom: 16px;
  padding-left: 12px;
  border-left: 3px solid #ffee20;
  letter-spacing: 0.3px;
}
.sd-description {
  font-size: var(--text-sm);
  color: rgba(255,255,255,0.65);
  line-height: 1.7;
  word-break: break-word;
  margin-bottom: 28px;
}

/* ── Playlist Table ───────────────────────────────────────────── */
.sd-table-header {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  background: rgba(255,238,32,0.05);
  border-radius: 8px;
  border: 1px solid rgba(255,238,32,0.08);
  margin-bottom: 4px;
}
.sd-th {
  font-size: 11px;
  color: #ffee20;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}
.sd-playlist-row {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;
  border-bottom: 1px solid rgba(255,255,255,0.03);
}
.sd-playlist-row:hover { background: rgba(255,255,255,0.05); }
.sd-playlist-num {
  font-size: var(--text-sm);
  color: rgba(255,255,255,0.35);
  width: 32px;
  text-align: center;
  font-weight: 600;
}
.sd-playlist-thumb {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  object-fit: cover;
  margin-left: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
}
.sd-playlist-title {
  font-size: var(--text-sm);
  font-weight: 500;
  color: #fff;
  flex: 1;
  margin-left: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sd-playlist-meta {
  font-size: 13px;
  color: rgba(255,255,255,0.45);
}

/* ── Streamer Row ─────────────────────────────────────────────── */
.sd-streamer-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s;
  border: 1px solid transparent;
}
.sd-streamer-row:hover {
  background: rgba(255,255,255,0.04);
  border-color: rgba(255,255,255,0.06);
}
.sd-rank-badge {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}
.sd-rank-badge--gold   { background: rgba(255,215,0,0.2); color: #FFD700; border: 1px solid rgba(255,215,0,0.4); }
.sd-rank-badge--silver { background: rgba(192,192,192,0.15); color: #C0C0C0; border: 1px solid rgba(192,192,192,0.3); }
.sd-rank-badge--bronze { background: rgba(205,127,50,0.15); color: #CD7F32; border: 1px solid rgba(205,127,50,0.3); }
.sd-rank-badge--default { background: rgba(255,255,255,0.05); color: rgba(255,255,255,0.4); border: 1px solid rgba(255,255,255,0.06); }
.sd-streamer-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
}
.sd-streamer-avatar--top { border: 2px solid rgba(255,238,32,0.25); }
.sd-streamer-name {
  flex: 1;
  min-width: 0;
  font-size: var(--text-sm);
  color: #fff;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sd-streamer-count {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: rgba(255,255,255,0.45);
  font-weight: 500;
}
.sd-streamer-count svg { font-size: var(--text-sm); color: rgba(255,255,255,0.3); }

/* ── Video Grid ───────────────────────────────────────────────── */
.sd-video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
}
.sd-card {
  background: rgba(255,255,255,0.04);
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.25s;
  border: 1px solid rgba(255,255,255,0.06);
}
.sd-card:hover {
  background: rgba(255,255,255,0.08);
  transform: translateY(-3px);
  border-color: rgba(255,238,32,0.2);
  box-shadow: 0 8px 24px rgba(0,0,0,0.3);
}
.sd-card-thumb {
  position: relative;
  padding-top: 56.25%;
  overflow: hidden;
}
.sd-card-thumb img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.sd-card-body {
  padding: 12px;
}
.sd-card-title {
  font-size: var(--text-sm);
  font-weight: 500;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sd-card-meta {
  font-size: var(--text-xs);
  color: rgba(255,255,255,0.45);
  margin-top: 4px;
}

/* ── Sidebar Cards ────────────────────────────────────────────── */
.sd-sidebar-card {
  background: rgba(255,255,255,0.03);
  border-radius: 14px;
  padding: 22px;
  margin-bottom: 16px;
  border: 1px solid rgba(255,255,255,0.06);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  transition: border-color 0.2s;
}
.sd-sidebar-card:hover { border-color: rgba(255,238,32,0.15); }
.sd-sidebar-card--gold { border-color: rgba(255,238,32,0.2); }
.sd-sidebar-card-title {
  font-size: 13px;
  font-weight: 600;
  color: #ffee20;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 16px;
}
.sd-detail-row {
  margin-bottom: 14px;
}
.sd-detail-label {
  font-size: 11px;
  color: rgba(255,255,255,0.4);
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 3px;
}
.sd-detail-value {
  font-size: var(--text-sm);
  color: #fff;
  font-weight: 500;
}
.sd-detail-mono {
  font-family: "SF Mono", "Monaco", "Inconsolata", monospace;
  letter-spacing: 0.5px;
}

/* ── Royalty Bars ─────────────────────────────────────────────── */
.sd-royalty-row {
  margin-bottom: 12px;
}
.sd-royalty-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.sd-royalty-name {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--text-sm);
  color: #fff;
  font-weight: 500;
}
.sd-royalty-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}
.sd-royalty-dot--primary {
  background: #ffee20;
  box-shadow: 0 0 6px rgba(255,238,32,0.4);
}
.sd-royalty-dot--secondary {
  background: rgba(255,255,255,0.25);
}
.sd-royalty-pct {
  font-size: 15px;
  font-weight: 700;
}
.sd-royalty-pct--primary { color: #ffee20; }
.sd-royalty-pct--secondary { color: rgba(255,255,255,0.6); }
.sd-royalty-bar {
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background: rgba(255,255,255,0.06);
  overflow: hidden;
}
.sd-royalty-fill {
  height: 100%;
  border-radius: 2px;
  transition: width 0.4s ease;
}
.sd-royalty-fill--primary { background: #ffee20; }
.sd-royalty-fill--secondary { background: rgba(255,255,255,0.25); }

/* ── Collaborator Row ─────────────────────────────────────────── */
.sd-collab-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}
.sd-collab-role {
  font-size: 13px;
  color: rgba(255,255,255,0.45);
}
.sd-collab-name {
  font-size: 13px;
  color: #fff;
  font-weight: 500;
}

/* ── Collectable Info Card ────────────────────────────────────── */
.sd-collectable-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border: 1px solid rgba(255,238,32,0.25);
  background: rgba(255,238,32,0.04);
  border-radius: 12px;
  margin-bottom: 20px;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}
.sd-collectable-label {
  font-size: 13px;
  color: rgba(255,255,255,0.5);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.sd-collectable-value {
  font-size: 17px;
  color: #fff;
  margin-top: 2px;
}
.sd-collectable-buy {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #ffee20;
  font-size: 15px;
  cursor: pointer;
  transition: opacity 0.2s;
}
.sd-collectable-buy:hover { opacity: 0.8; }
.sd-collectable-platform {
  width: 32px;
  cursor: pointer;
  transition: opacity 0.2s;
}
.sd-collectable-platform:hover { opacity: 0.8; }

/* ── Pro Gate ─────────────────────────────────────────────────── */
.sd-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.sd-section-header .sd-section-title {
  margin-bottom: 0;
}
.sd-pro-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 20px;
  background: linear-gradient(135deg, rgba(255,238,32,0.15), rgba(255,200,0,0.1));
  border: 1px solid rgba(255,238,32,0.3);
  color: #ffee20;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
}
.sd-pro-container {
  position: relative;
  min-height: 260px;
}
.sd-pro-container--locked .sd-pro-blur-wrap {
  filter: blur(10px);
  -webkit-filter: blur(10px);
  opacity: 0.35;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}
.sd-pro-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  background: radial-gradient(ellipse at center, rgba(10,10,10,0.7) 0%, transparent 70%);
}
.sd-pro-overlay-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px 32px;
  text-align: center;
}
.sd-pro-lock-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,238,32,0.12);
  border: 1px solid rgba(255,238,32,0.3);
  color: #ffee20;
  margin-bottom: 4px;
  box-shadow: 0 0 30px rgba(255,238,32,0.15);
}
.sd-pro-overlay-title {
  font-size: var(--text-md);
  font-weight: 600;
  color: #fff;
  margin: 0;
}
.sd-pro-overlay-desc {
  font-size: 13px;
  color: rgba(255,255,255,0.5);
  margin: 0;
}
.sd-pro-upgrade-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 24px;
  margin-top: 4px;
  background: linear-gradient(135deg, #ffee20, #ffc800);
  color: #000;
  font-size: 13px;
  font-weight: 700;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  letter-spacing: 0.3px;
}
.sd-pro-upgrade-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 20px rgba(255,238,32,0.3);
}

/* ── Empty State ──────────────────────────────────────────────── */
.sd-empty-state {
  padding: 48px 24px;
  text-align: center;
  border: 1px dashed rgba(255,255,255,0.08);
  border-radius: 12px;
  background: rgba(255,255,255,0.01);
}
.sd-empty-icon {
  font-size: 40px;
  color: rgba(255,255,255,0.12);
  margin-bottom: 8px;
}
.sd-empty-text {
  font-size: var(--text-sm);
  color: rgba(255,255,255,0.35);
}

/* ── Flag Card ────────────────────────────────────────────────── */
.sd-flag-card {
  margin-top: 16px;
  padding: 16px 20px;
  border-radius: 10px;
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(255,255,255,0.06);
}
.sd-flag-header {
  display: flex;
  align-items: center;
  gap: 8px;
}
.sd-flag-header img { width: 16px; height: 16px; }
.sd-flag-title {
  font-size: 13px;
  color: rgba(255,255,255,0.5);
}
.sd-flag-msg {
  font-size: 13px;
  color: rgba(255,255,255,0.35);
  margin-top: 8px;
}
.sd-flag-btn {
  margin-top: 10px;
  padding: 6px 16px;
  background: transparent;
  color: #fff;
  font-size: var(--text-xs);
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.2s;
}
.sd-flag-btn:hover { border-color: rgba(255,255,255,0.4); }

/* ── Loading ──────────────────────────────────────────────────── */
.sd-loading {
  display: flex;
  justify-content: center;
  padding: 32px 0;
}

/* ── Responsive ───────────────────────────────────────────────── */
@media (max-width: 900px) {
  .sd-hero { padding: 24px 16px; }
  .sd-hero-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .sd-hero-cover { width: 180px; height: 180px; }
  .sd-stat-row { justify-content: center; }
  .sd-actions { justify-content: center; }
  .sd-layout { flex-direction: column; padding: 16px; }
  .sd-main { padding-right: 0; }
  .sd-sidebar {
    width: 100%;
    border-left: none;
    border-top: 1px solid rgba(255,238,32,0.08);
    padding-left: 0;
    padding-top: 24px;
    margin-top: 24px;
  }
  .sd-tabs-wrapper { padding: 0 16px; }
}

@media (max-width: 600px) {
  .sd-hero-cover { width: 140px; height: 140px; }
  .sd-title { font-size: 22px; }
  .sd-stat-card { padding: 6px 10px; }
  .sd-stat-value { font-size: 13px; }
  .sd-video-grid { grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SongDetails/SongDetails.css"],"names":[],"mappings":"AAAA;;oEAEoE;;AAEpE;EACE,6DAA6D;EAC7D,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;AACA,iBAAiB,WAAW,EAAE;AAC9B,eAAe,yBAAyB,EAAE;;AAE1C,oEAAoE;AACpE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,6GAA6G;AAC/G;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yEAAyE;EACzE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;AACxB;AACA,mBAAmB,cAAc,EAAE;;AAEnC,oEAAoE;AACpE;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,mCAA2B;UAA3B,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA,sBAAsB,kCAAkC,EAAE;AAC1D,gBAAgB,yBAAyB,EAAE,cAAc,EAAE;AAC3D;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,uCAAuC;EACvC,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;AACA,qBAAqB,mBAAmB,EAAE;AAC1C,mBAAmB,yBAAyB,EAAE;AAC9C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,6BAA6B;AAC/B;AACA,sBAAsB,mCAAmC,EAAE;AAC3D,oBAAoB,yBAAyB,EAAE;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,uCAAuC;EACvC,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,iCAAiC;EACjC,WAAW;AACb;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,+BAA+B;EAC/B,mCAA2B;UAA3B,2BAA2B;EAC3B,6CAA6C;EAC7C,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,MAAM;EACN,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,OAAO;EACP,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,cAAc;EACd,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA,oEAAoE;AACpE;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,+CAA+C;AACjD;AACA,yBAAyB,kCAAkC,EAAE;AAC7D;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,qCAAqC;AACvC;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,OAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,yBAAyB,+BAA+B,EAAE,cAAc,EAAE,qCAAqC,EAAE;AACjH,yBAAyB,kCAAkC,EAAE,cAAc,EAAE,uCAAuC,EAAE;AACtH,yBAAyB,iCAAiC,EAAE,cAAc,EAAE,sCAAsC,EAAE;AACpH,0BAA0B,kCAAkC,EAAE,4BAA4B,EAAE,wCAAwC,EAAE;AACtI;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA,2BAA2B,uCAAuC,EAAE;AACpE;EACE,OAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;AACA,yBAAyB,yBAAyB,EAAE,4BAA4B,EAAE;;AAElF,oEAAoE;AACpE;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;AACA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,kCAAkC;EAClC,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,oEAAoE;AACpE;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mCAA2B;UAA3B,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA,yBAAyB,mCAAmC,EAAE;AAC9D,yBAAyB,kCAAkC,EAAE;AAC7D;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,0DAA0D;EAC1D,qBAAqB;AACvB;;AAEA,oEAAoE;AACpE;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA,2BAA2B,cAAc,EAAE;AAC3C,6BAA6B,4BAA4B,EAAE;AAC3D;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;AACA,4BAA4B,mBAAmB,EAAE;AACjD,8BAA8B,kCAAkC,EAAE;;AAElE,oEAAoE;AACpE;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,mCAA2B;UAA3B,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;AACA,4BAA4B,YAAY,EAAE;AAC1C;EACE,WAAW;EACX,eAAe;EACf,wBAAwB;AAC1B;AACA,iCAAiC,YAAY,EAAE;;AAE/C,oEAAoE;AACpE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,+EAA+E;EAC/E,sCAAsC;EACtC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,sFAAsF;AACxF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,sCAAsC;EACtC,cAAc;EACd,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,2CAA2C;EAC3C,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,sBAAsB,WAAW,EAAE,YAAY,EAAE;AACjD;EACE,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;AACA,qBAAqB,mCAAmC,EAAE;;AAE1D,oEAAoE;AACpE;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA,oEAAoE;AACpE;EACE,WAAW,kBAAkB,EAAE;EAC/B;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;EACA,iBAAiB,YAAY,EAAE,aAAa,EAAE;EAC9C,eAAe,uBAAuB,EAAE;EACxC,cAAc,uBAAuB,EAAE;EACvC,aAAa,sBAAsB,EAAE,aAAa,EAAE;EACpD,WAAW,gBAAgB,EAAE;EAC7B;IACE,WAAW;IACX,iBAAiB;IACjB,2CAA2C;IAC3C,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;EACA,mBAAmB,eAAe,EAAE;AACtC;;AAEA;EACE,iBAAiB,YAAY,EAAE,aAAa,EAAE;EAC9C,YAAY,eAAe,EAAE;EAC7B,gBAAgB,iBAAiB,EAAE;EACnC,iBAAiB,eAAe,EAAE;EAClC,iBAAiB,4DAA4D,EAAE;AACjF","sourcesContent":["/* ═══════════════════════════════════════════════════════════════\n   Song Details Page — SIKI Design System\n   ═══════════════════════════════════════════════════════════════ */\n\n.sd-page {\n  background: linear-gradient(135deg, #0a0a0a 0%, #111118 100%);\n  min-height: 100vh;\n  color: #fff;\n  padding-bottom: 100px;\n}\n\n/* ── Back Button ──────────────────────────────────────────────── */\n.sd-back {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 0 0 16px;\n  color: rgba(255, 255, 255, 0.45);\n  font-size: 13px;\n  cursor: pointer;\n  transition: color 0.2s;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n.sd-back:hover { color: #fff; }\n.sd-back svg { font-size: var(--text-sm); }\n\n/* ── Hero Section ─────────────────────────────────────────────── */\n.sd-hero {\n  position: relative;\n  overflow: hidden;\n  padding: 48px 32px 40px;\n}\n.sd-hero-bg {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n}\n.sd-hero-bg img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: blur(60px) brightness(0.3);\n  transform: scale(1.2);\n}\n.sd-hero-bg::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(10,10,10,0.2) 0%, rgba(10,10,10,0.65) 55%, rgba(10,10,10,0.95) 100%);\n}\n.sd-hero-content {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  gap: 32px;\n  align-items: flex-start;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n.sd-hero-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.sd-hero-cover {\n  width: 220px;\n  height: 220px;\n  object-fit: cover;\n  border-radius: 14px;\n  box-shadow: 0 12px 40px rgba(0,0,0,0.6), 0 0 0 1px rgba(255,255,255,0.06);\n  flex-shrink: 0;\n}\n\n/* Hero typography */\n.sd-title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.sd-title {\n  font-size: 28px;\n  font-weight: 700;\n  color: #fff;\n  line-height: 1.2;\n}\n.sd-artist {\n  font-size: var(--text-md);\n  color: rgba(255,255,255,0.65);\n  cursor: pointer;\n  transition: color 0.2s;\n}\n.sd-artist:hover { color: #ffee20; }\n\n/* ── Stat Cards ───────────────────────────────────────────────── */\n.sd-stat-row {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-top: 4px;\n}\n.sd-stat-card {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: rgba(255,255,255,0.06);\n  border: 1px solid rgba(255,255,255,0.08);\n  border-radius: 10px;\n  padding: 8px 14px;\n  backdrop-filter: blur(12px);\n  transition: border-color 0.2s;\n}\n.sd-stat-card:hover { border-color: rgba(255,238,32,0.3); }\n.sd-stat-icon { font-size: var(--text-lg); color: #ffee20; }\n.sd-stat-value {\n  font-size: 15px;\n  font-weight: 600;\n  color: #fff;\n  line-height: 1.2;\n}\n.sd-stat-label {\n  font-size: 11px;\n  color: rgba(255,255,255,0.4);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  line-height: 1.2;\n}\n\n/* ── Collectable Badge ────────────────────────────────────────── */\n.sd-collectable-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  border-radius: 8px;\n  background: rgba(255,238,32,0.12);\n  border: 1px solid rgba(255,238,32,0.35);\n  font-size: var(--text-xs);\n  color: #ffee20;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n/* ── Action Buttons ───────────────────────────────────────────── */\n.sd-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 8px;\n}\n.sd-btn-play {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 28px;\n  background: #ffee20;\n  color: #000;\n  font-weight: 600;\n  font-size: var(--text-sm);\n  border: none;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n.sd-btn-play:hover { background: #e6d61c; }\n.sd-btn-play svg { font-size: var(--text-lg); }\n.sd-btn-share {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 20px;\n  background: transparent;\n  color: #fff;\n  font-size: 13px;\n  border: 1px solid rgba(255,255,255,0.2);\n  border-radius: 25px;\n  cursor: pointer;\n  transition: border-color 0.2s;\n}\n.sd-btn-share:hover { border-color: rgba(255,255,255,0.5); }\n.sd-btn-share svg { font-size: var(--text-md); }\n.sd-btn-more {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.06);\n  border: 1px solid rgba(255,255,255,0.1);\n  color: rgba(255,255,255,0.7);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.sd-btn-more:hover {\n  background: rgba(255,255,255,0.1);\n  color: #fff;\n}\n\n/* ── Tab Navigation ───────────────────────────────────────────── */\n.sd-tabs-wrapper {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: rgba(10,10,10,0.95);\n  backdrop-filter: blur(12px);\n  border-bottom: 1px solid rgba(255,238,32,0.1);\n  padding: 0 32px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* ── Layout: Main + Sidebar ───────────────────────────────────── */\n.sd-layout {\n  display: flex;\n  gap: 0;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 28px 32px;\n}\n.sd-main {\n  flex: 1;\n  min-width: 0;\n  padding-right: 32px;\n}\n.sd-sidebar {\n  width: 340px;\n  flex-shrink: 0;\n  border-left: 1px solid rgba(255,238,32,0.08);\n  padding-left: 24px;\n}\n\n/* ── Section Titles ───────────────────────────────────────────── */\n.sd-section {\n  margin-bottom: 32px;\n}\n.sd-section-title {\n  font-size: var(--text-md);\n  font-weight: 700;\n  color: #fff;\n  margin-bottom: 16px;\n  padding-left: 12px;\n  border-left: 3px solid #ffee20;\n  letter-spacing: 0.3px;\n}\n.sd-description {\n  font-size: var(--text-sm);\n  color: rgba(255,255,255,0.65);\n  line-height: 1.7;\n  word-break: break-word;\n  margin-bottom: 28px;\n}\n\n/* ── Playlist Table ───────────────────────────────────────────── */\n.sd-table-header {\n  display: flex;\n  align-items: center;\n  padding: 10px 16px;\n  background: rgba(255,238,32,0.05);\n  border-radius: 8px;\n  border: 1px solid rgba(255,238,32,0.08);\n  margin-bottom: 4px;\n}\n.sd-th {\n  font-size: 11px;\n  color: #ffee20;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n}\n.sd-playlist-row {\n  display: flex;\n  align-items: center;\n  padding: 10px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.15s;\n  border-bottom: 1px solid rgba(255,255,255,0.03);\n}\n.sd-playlist-row:hover { background: rgba(255,255,255,0.05); }\n.sd-playlist-num {\n  font-size: var(--text-sm);\n  color: rgba(255,255,255,0.35);\n  width: 32px;\n  text-align: center;\n  font-weight: 600;\n}\n.sd-playlist-thumb {\n  width: 44px;\n  height: 44px;\n  border-radius: 8px;\n  object-fit: cover;\n  margin-left: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.3);\n}\n.sd-playlist-title {\n  font-size: var(--text-sm);\n  font-weight: 500;\n  color: #fff;\n  flex: 1;\n  margin-left: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.sd-playlist-meta {\n  font-size: 13px;\n  color: rgba(255,255,255,0.45);\n}\n\n/* ── Streamer Row ─────────────────────────────────────────────── */\n.sd-streamer-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 16px;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.15s;\n  border: 1px solid transparent;\n}\n.sd-streamer-row:hover {\n  background: rgba(255,255,255,0.04);\n  border-color: rgba(255,255,255,0.06);\n}\n.sd-rank-badge {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n.sd-rank-badge--gold   { background: rgba(255,215,0,0.2); color: #FFD700; border: 1px solid rgba(255,215,0,0.4); }\n.sd-rank-badge--silver { background: rgba(192,192,192,0.15); color: #C0C0C0; border: 1px solid rgba(192,192,192,0.3); }\n.sd-rank-badge--bronze { background: rgba(205,127,50,0.15); color: #CD7F32; border: 1px solid rgba(205,127,50,0.3); }\n.sd-rank-badge--default { background: rgba(255,255,255,0.05); color: rgba(255,255,255,0.4); border: 1px solid rgba(255,255,255,0.06); }\n.sd-streamer-avatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n.sd-streamer-avatar--top { border: 2px solid rgba(255,238,32,0.25); }\n.sd-streamer-name {\n  flex: 1;\n  min-width: 0;\n  font-size: var(--text-sm);\n  color: #fff;\n  font-weight: 500;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.sd-streamer-count {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n  color: rgba(255,255,255,0.45);\n  font-weight: 500;\n}\n.sd-streamer-count svg { font-size: var(--text-sm); color: rgba(255,255,255,0.3); }\n\n/* ── Video Grid ───────────────────────────────────────────────── */\n.sd-video-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 16px;\n}\n.sd-card {\n  background: rgba(255,255,255,0.04);\n  border-radius: 12px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: all 0.25s;\n  border: 1px solid rgba(255,255,255,0.06);\n}\n.sd-card:hover {\n  background: rgba(255,255,255,0.08);\n  transform: translateY(-3px);\n  border-color: rgba(255,238,32,0.2);\n  box-shadow: 0 8px 24px rgba(0,0,0,0.3);\n}\n.sd-card-thumb {\n  position: relative;\n  padding-top: 56.25%;\n  overflow: hidden;\n}\n.sd-card-thumb img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.sd-card-body {\n  padding: 12px;\n}\n.sd-card-title {\n  font-size: var(--text-sm);\n  font-weight: 500;\n  color: #fff;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.sd-card-meta {\n  font-size: var(--text-xs);\n  color: rgba(255,255,255,0.45);\n  margin-top: 4px;\n}\n\n/* ── Sidebar Cards ────────────────────────────────────────────── */\n.sd-sidebar-card {\n  background: rgba(255,255,255,0.03);\n  border-radius: 14px;\n  padding: 22px;\n  margin-bottom: 16px;\n  border: 1px solid rgba(255,255,255,0.06);\n  backdrop-filter: blur(10px);\n  transition: border-color 0.2s;\n}\n.sd-sidebar-card:hover { border-color: rgba(255,238,32,0.15); }\n.sd-sidebar-card--gold { border-color: rgba(255,238,32,0.2); }\n.sd-sidebar-card-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #ffee20;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 16px;\n}\n.sd-detail-row {\n  margin-bottom: 14px;\n}\n.sd-detail-label {\n  font-size: 11px;\n  color: rgba(255,255,255,0.4);\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  margin-bottom: 3px;\n}\n.sd-detail-value {\n  font-size: var(--text-sm);\n  color: #fff;\n  font-weight: 500;\n}\n.sd-detail-mono {\n  font-family: \"SF Mono\", \"Monaco\", \"Inconsolata\", monospace;\n  letter-spacing: 0.5px;\n}\n\n/* ── Royalty Bars ─────────────────────────────────────────────── */\n.sd-royalty-row {\n  margin-bottom: 12px;\n}\n.sd-royalty-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n}\n.sd-royalty-name {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: var(--text-sm);\n  color: #fff;\n  font-weight: 500;\n}\n.sd-royalty-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n.sd-royalty-dot--primary {\n  background: #ffee20;\n  box-shadow: 0 0 6px rgba(255,238,32,0.4);\n}\n.sd-royalty-dot--secondary {\n  background: rgba(255,255,255,0.25);\n}\n.sd-royalty-pct {\n  font-size: 15px;\n  font-weight: 700;\n}\n.sd-royalty-pct--primary { color: #ffee20; }\n.sd-royalty-pct--secondary { color: rgba(255,255,255,0.6); }\n.sd-royalty-bar {\n  width: 100%;\n  height: 4px;\n  border-radius: 2px;\n  background: rgba(255,255,255,0.06);\n  overflow: hidden;\n}\n.sd-royalty-fill {\n  height: 100%;\n  border-radius: 2px;\n  transition: width 0.4s ease;\n}\n.sd-royalty-fill--primary { background: #ffee20; }\n.sd-royalty-fill--secondary { background: rgba(255,255,255,0.25); }\n\n/* ── Collaborator Row ─────────────────────────────────────────── */\n.sd-collab-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n.sd-collab-role {\n  font-size: 13px;\n  color: rgba(255,255,255,0.45);\n}\n.sd-collab-name {\n  font-size: 13px;\n  color: #fff;\n  font-weight: 500;\n}\n\n/* ── Collectable Info Card ────────────────────────────────────── */\n.sd-collectable-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border: 1px solid rgba(255,238,32,0.25);\n  background: rgba(255,238,32,0.04);\n  border-radius: 12px;\n  margin-bottom: 20px;\n  backdrop-filter: blur(10px);\n}\n.sd-collectable-label {\n  font-size: 13px;\n  color: rgba(255,255,255,0.5);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n.sd-collectable-value {\n  font-size: 17px;\n  color: #fff;\n  margin-top: 2px;\n}\n.sd-collectable-buy {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #ffee20;\n  font-size: 15px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n.sd-collectable-buy:hover { opacity: 0.8; }\n.sd-collectable-platform {\n  width: 32px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n.sd-collectable-platform:hover { opacity: 0.8; }\n\n/* ── Pro Gate ─────────────────────────────────────────────────── */\n.sd-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n.sd-section-header .sd-section-title {\n  margin-bottom: 0;\n}\n.sd-pro-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: 20px;\n  background: linear-gradient(135deg, rgba(255,238,32,0.15), rgba(255,200,0,0.1));\n  border: 1px solid rgba(255,238,32,0.3);\n  color: #ffee20;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1px;\n}\n.sd-pro-container {\n  position: relative;\n  min-height: 260px;\n}\n.sd-pro-container--locked .sd-pro-blur-wrap {\n  filter: blur(10px);\n  -webkit-filter: blur(10px);\n  opacity: 0.35;\n  pointer-events: none;\n  user-select: none;\n}\n.sd-pro-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 2;\n  background: radial-gradient(ellipse at center, rgba(10,10,10,0.7) 0%, transparent 70%);\n}\n.sd-pro-overlay-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 24px 32px;\n  text-align: center;\n}\n.sd-pro-lock-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255,238,32,0.12);\n  border: 1px solid rgba(255,238,32,0.3);\n  color: #ffee20;\n  margin-bottom: 4px;\n  box-shadow: 0 0 30px rgba(255,238,32,0.15);\n}\n.sd-pro-overlay-title {\n  font-size: var(--text-md);\n  font-weight: 600;\n  color: #fff;\n  margin: 0;\n}\n.sd-pro-overlay-desc {\n  font-size: 13px;\n  color: rgba(255,255,255,0.5);\n  margin: 0;\n}\n.sd-pro-upgrade-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 24px;\n  margin-top: 4px;\n  background: linear-gradient(135deg, #ffee20, #ffc800);\n  color: #000;\n  font-size: 13px;\n  font-weight: 700;\n  border: none;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n  letter-spacing: 0.3px;\n}\n.sd-pro-upgrade-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 20px rgba(255,238,32,0.3);\n}\n\n/* ── Empty State ──────────────────────────────────────────────── */\n.sd-empty-state {\n  padding: 48px 24px;\n  text-align: center;\n  border: 1px dashed rgba(255,255,255,0.08);\n  border-radius: 12px;\n  background: rgba(255,255,255,0.01);\n}\n.sd-empty-icon {\n  font-size: 40px;\n  color: rgba(255,255,255,0.12);\n  margin-bottom: 8px;\n}\n.sd-empty-text {\n  font-size: var(--text-sm);\n  color: rgba(255,255,255,0.35);\n}\n\n/* ── Flag Card ────────────────────────────────────────────────── */\n.sd-flag-card {\n  margin-top: 16px;\n  padding: 16px 20px;\n  border-radius: 10px;\n  background: rgba(255,255,255,0.03);\n  border: 1px solid rgba(255,255,255,0.06);\n}\n.sd-flag-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.sd-flag-header img { width: 16px; height: 16px; }\n.sd-flag-title {\n  font-size: 13px;\n  color: rgba(255,255,255,0.5);\n}\n.sd-flag-msg {\n  font-size: 13px;\n  color: rgba(255,255,255,0.35);\n  margin-top: 8px;\n}\n.sd-flag-btn {\n  margin-top: 10px;\n  padding: 6px 16px;\n  background: transparent;\n  color: #fff;\n  font-size: var(--text-xs);\n  border: 1px solid rgba(255,255,255,0.2);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: border-color 0.2s;\n}\n.sd-flag-btn:hover { border-color: rgba(255,255,255,0.4); }\n\n/* ── Loading ──────────────────────────────────────────────────── */\n.sd-loading {\n  display: flex;\n  justify-content: center;\n  padding: 32px 0;\n}\n\n/* ── Responsive ───────────────────────────────────────────────── */\n@media (max-width: 900px) {\n  .sd-hero { padding: 24px 16px; }\n  .sd-hero-content {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n  .sd-hero-cover { width: 180px; height: 180px; }\n  .sd-stat-row { justify-content: center; }\n  .sd-actions { justify-content: center; }\n  .sd-layout { flex-direction: column; padding: 16px; }\n  .sd-main { padding-right: 0; }\n  .sd-sidebar {\n    width: 100%;\n    border-left: none;\n    border-top: 1px solid rgba(255,238,32,0.08);\n    padding-left: 0;\n    padding-top: 24px;\n    margin-top: 24px;\n  }\n  .sd-tabs-wrapper { padding: 0 16px; }\n}\n\n@media (max-width: 600px) {\n  .sd-hero-cover { width: 140px; height: 140px; }\n  .sd-title { font-size: 22px; }\n  .sd-stat-card { padding: 6px 10px; }\n  .sd-stat-value { font-size: 13px; }\n  .sd-video-grid { grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
